module.exports = __webpack_public_path__ + "img/SWP_Shield_03.0ee51287.png";